import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
// Fonts are self-hosted (Fontsource, bundled by Vite): no requests to Google.
import '@fontsource-variable/manrope'
import '@fontsource-variable/public-sans'
import '@fontsource-variable/onest'
import './index.css'
import { configureAuth } from '@/services/auth'

// Configure Amplify before React renders (important for OAuth redirect handling).
configureAuth()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
